import { useEffect, useState } from 'react';
import { useGameStore } from '../stores/gameStore';

// Full-screen blocker shown while the player's own node is in DDoS shutdown.
// It covers the whole UI (no action is possible) and counts down the remaining
// time; when it expires it refreshes the player so the overlay clears.
export default function ShutdownOverlay() {
  const player = useGameStore(s => s.player);
  const loadPlayer = useGameStore(s => s.loadPlayer);
  const [now, setNow] = useState(() => Date.now());

  const until = player?.shutdownUntil ? new Date(player.shutdownUntil).getTime() : 0;
  const active = until > now;

  // Tick once a second while shut down.
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [active]);

  // When the timer runs out, pull fresh player data to drop the overlay.
  useEffect(() => {
    if (until > 0 && until <= now) loadPlayer();
  }, [until, now, loadPlayer]);

  if (!active) return null;

  const totalSec = Math.max(0, Math.ceil((until - now) / 1000));
  const mm = String(Math.floor(totalSec / 60)).padStart(2, '0');
  const ss = String(totalSec % 60).padStart(2, '0');

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 2000,
      background: 'rgba(2,2,6,0.95)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'monospace', textAlign: 'center', padding: '1.5rem',
    }}>
      <div style={{ maxWidth: '520px' }}>
        <div style={{ fontSize: '2.4rem', color: '#ef4444', fontWeight: 'bold', letterSpacing: '0.1em' }}>
          {player?.shutdownReason === 'format'
            ? '⚠ NODE FORMATTING'
            : player?.shutdownReason === 'ipchange'
              ? '⚠ CHANGING IP ADDRESS'
              : '⚠ NODE SHUTDOWN'}
        </div>
        <p style={{ color: '#e2e8f0', marginTop: '1rem', lineHeight: 1.6 }}>
          {player?.shutdownReason === 'format'
            ? <>Your node is being wiped and is rebooting. The encrypted HD was preserved.<br /></>
            : player?.shutdownReason === 'ipchange'
              ? <>Your node is offline while its IP address is being changed.<br /></>
              : <>Your node was knocked offline by a DDoS overload.<br /></>}
          While it is down you are unreachable and <strong>cannot perform any action</strong>.
        </p>
        <div style={{
          margin: '1.75rem auto 0', padding: '1rem 1.5rem', display: 'inline-block',
          border: '1px solid #7f1d1d', borderRadius: '8px', background: '#160606',
        }}>
          <div style={{ color: '#888', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            Restart in
          </div>
          <div style={{ color: '#fbbf24', fontSize: '2.6rem', fontWeight: 'bold', lineHeight: 1.1 }}>
            {mm}:{ss}
          </div>
        </div>
        <p style={{ color: '#6b7280', marginTop: '1.5rem', fontSize: '0.8rem' }}>
          The screen unlocks automatically when your node comes back online.
        </p>
      </div>
    </div>
  );
}
